import Const from 'constants';
import {getPlayerService} from 'services/sports/factory';
import {getDefaultExposure} from 'helpers/player-helper';
import Action from 'actions';

let Player = {
    createPoolsOfPlayers(params = {}) {
        return (dispatch, getState) => {
            const {
                sportConfig,
                playersData: {players},
            } = getState();
            const {filterPlayersBeforePreparingPools = true} = params;

            const pools = getPlayerService(sportConfig).exec('preparePoolsOfPlayers', {
                players: players.all(),
                filterPlayersBeforePreparingPools,
            });

            dispatch(this.setPoolsOfPlayers(pools));
        };
    },
    applyPlayers(players) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();
            dispatch(this.setIsPlayersGroupReady(false));
            dispatch(this.loadFiltersFromStorage('pointsType'));
            dispatch(this.setPlayers(players));
            dispatch(this.loadFiltersFromStorage('playersData'));
            dispatch(this.applySympathy());
            dispatch(this.setPointsBoundary());
            dispatch(this.setSalaryBoundary());

            getPlayerService(sportConfig).exec('afterGettingPlayers', {dispatch}, {});

            dispatch(this.setPlayersCounters());
            dispatch(this.setIsPlayersGroupReady(true));
        };
    },
    applyUpdatedPlayers(players, options = {}) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            try {
                dispatch(this.setIsPlayersGroupReady(false));

                options.updatePlayersAfterRefreshingProjections = true;
                dispatch(this.setPlayers(players, options));

                dispatch(this.loadFiltersFromStorage('updatePoints'));

                dispatch(this.setPointsBoundary());
                dispatch(this.setSalaryBoundary());
                dispatch(this.setPlayersCounters());

                getPlayerService(sportConfig).exec('afterGettingPlayers', {dispatch, initial: false}, {});

                dispatch(this.setIsPlayersGroupReady(true));
            } catch (e) {
                dispatch(this.setIsPlayersGroupReady(true));
                console.error(e);
                throw e;
            }
        };
    },
    applyDeletedPlayers(playerIds) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            try {
                dispatch(this.setIsPlayersGroupReady(false));

                dispatch({
                    type: Const.DELETE_PLAYERS_BY_IDS,
                    data: {
                        playerIds,
                    },
                });

                dispatch(this.setPointsBoundary());
                dispatch(this.setSalaryBoundary());
                dispatch(this.setPlayersCounters());

                getPlayerService(sportConfig).exec('afterGettingPlayers', {dispatch, initial: false}, {});

                dispatch(this.setIsPlayersGroupReady(true));
            } catch (e) {
                dispatch(this.setIsPlayersGroupReady(true));
                console.error(e);
                throw e;
            }
        };
    },
    updatePlayersWhoseGameStatusChanged(gameModels) {
        return (dispatch, getState) => {
            const {
                playersData: {players},
                sportConfig,
            } = getState();

            if (!sportConfig.isSportMlb()) {
                return;
            }

            const playerService = getPlayerService(sportConfig);
            const playersOfActiveGames = [];
            const playersOfInactiveGames = [];

            gameModels.map((game) => {
                const gamePlayers = players.getPlayersByGameInfo(game.gameInfo);

                game.isActive
                    ? gamePlayers.map((player) => playersOfActiveGames.push(player))
                    : gamePlayers.map((player) => playersOfInactiveGames.push(player));
            });

            playerService.exec('updatePlayersWhoseGamesBecameInactive', {
                dispatch,
                players: playersOfInactiveGames,
            });

            playerService.exec('updatePlayersWhoseGamesBecameActive', {
                dispatch,
                players: playersOfActiveGames,
            });
        };
    },
    setIsPlayersGroupReady(value) {
        return {
            type: Const.SET_IS_PLAYERS_GROUP_READY,
            value,
        };
    },
    setUsageOfPlayersOnlyInCorrelationStacking(items) {
        return (dispatch) => {
            dispatch({
                type: Const.CORRELATION_STACKING_RESTRICT_PLAYERS,
                items,
            });

            dispatch(this.setPlayersCounters());

            dispatch(this.saveFiltersToStorage('playersData'));
        };
    },
    setPlayersCounters() {
        return (dispatch, getState) => {
            const {
                sportConfig,
                playersData: {players, filters},
                playersLock,
                playersExclusion,
                pointsBoundary,
                salaryBoundary,
                modesConfig,
            } = getState();

            const counters = {
                playersCount: 0,
                lockedCount: 0,
                lockedSalary: 0,
                totalExcludedQnt: 0,
                excludedByMode: {},
            };

            const playersList = players.all();
            const modes = modesConfig.all({asArr: true});

            Object.values(playersList).map((player) => {
                if (sportConfig.useGameFilter() && !inArray(player.team, filters.games)) {
                    return;
                }

                counters.playersCount++;

                let isLocked = false;
                let isExcluded = false;
                modes.map((mode) => {
                    if (playersLock.isLocked(player.getId(), mode.getRole())) {
                        counters.lockedSalary += player.getPropValueOfMode('salary', mode.getRole());
                        isLocked = true;
                        return;
                    }

                    if (!counters.excludedByMode.hasOwnProperty(mode.getRole())) {
                        counters.excludedByMode[mode.getRole()] = 0;
                    }

                    if (!player.isModeUsed(mode.getRole())) {
                        counters.excludedByMode[mode.getRole()]++;
                        return;
                    }

                    const points = player.getPropValueOfMode('userPoints', mode.getRole());
                    if (!pointsBoundary.isInBoundaries(points, mode.getRole())) {
                        counters.excludedByMode[mode.getRole()]++;
                        isExcluded = true;
                        return;
                    }

                    const role = mode.isUsedInSalaryFilter() ? mode.getRole() : Const.FLEX_MODE;
                    const salary = player.getPropValueOfMode('salary', role);
                    if (!salaryBoundary.isInBoundaries(salary, role)) {
                        counters.excludedByMode[mode.getRole()]++;
                        isExcluded = true;
                        return;
                    }

                    if (playersExclusion.isExcluded(player.getId(), mode.getRole())) {
                        counters.excludedByMode[mode.getRole()]++;
                        isExcluded = true;
                        return;
                    }

                    if (player.isExcludedByFilter()) {
                        counters.excludedByMode[mode.getRole()]++;
                        isExcluded = true;
                        return;
                    }
                });

                if (isLocked) {
                    counters.lockedCount++;
                }

                if (isExcluded) {
                    counters.totalExcludedQnt++;
                }
            });

            dispatch({
                type: Const.SET_PLAYERS_COUNTERS,
                counters,
            });
        };
    },
    updatePlayerParams(params, methodsToExecute = {}) {
        return (dispatch) => {
            dispatch({
                type: Const.UPDATE_PLAYER_PARAMS,
                data: params,
            });
            Object.keys(methodsToExecute).map((methodName) => {
                let params = methodsToExecute[methodName];

                try {
                    dispatch(this[methodName](...params));
                } catch (e) {
                    console.error('ACTION updatePlayerParams: ', e);
                }
            });
        };
    },
    setPlayersLineGroup(lineGroupPoints) {
        return (dispatch, getState) => {
            let state = getState();
            const {lineGroupFilter} = state.playersData;
            dispatch({
                type: Const.SET_PLAYERS_LINE_GROUP,
                data: lineGroupPoints,
            });
            dispatch(this.setLineGroups(lineGroupFilter.lineGroups));
            dispatch(this.updateNhlStackPlayers());
            dispatch(this.saveFiltersToStorage('playersData'));
            dispatch(this.setPlayersCounters());
        };
    },
    setPlayersPPLine(ppLinePoints) {
        return (dispatch) => {
            dispatch({
                type: Const.SET_PLAYERS_PP_LINE,
                data: ppLinePoints,
            });
            dispatch(this.updateNhlStackPlayers());
            dispatch(this.saveFiltersToStorage('playersData'));
        };
    },
    setPlayers(newPlayers = [], options = {}) {
        return (dispatch, getState) => {
            const {
                sportConfig,
                userPointsType,
                playersData: {players},
            } = getState();
            const {
                updatePlayersAfterRefreshingProjections = false,
                modificationType = Const.PLAYERS_MODIFICATION_TYPE_SET,
            } = options;

            let indexedPlayers = {};
            for (let player of newPlayers) {
                const expandedPlayer = getPlayerService(sportConfig).exec(
                    'getExpandedEntityParams',
                    {
                        player,
                        userPointsType: userPointsType.getUserPointsType(),
                        sportConfig,
                    },
                    {},
                );

                indexedPlayers[players.doIndex(player.playerId)] = {...expandedPlayer};
            }

            if (updatePlayersAfterRefreshingProjections) {
                indexedPlayers = getPlayerService(sportConfig).exec(
                    'updatePlayersAfterRefreshingProjections',
                    {indexedPlayers},
                    {},
                );
            }

            return dispatch(this.updatePlayersState(indexedPlayers, modificationType));
        };
    },
    addAbsentPlayersToPool(players = []) {
        return (dispatch, getState) => {
            const {sportConfig, userPointsType, playersData} = getState();
            const existingPlayers = playersData.players.all();
            const PlayerService = getPlayerService(sportConfig);

            dispatch(this.setIsPlayersGroupReady(false));

            const indexedPlayers = {};
            players.map((player) => {
                player = PlayerService.exec('annulPlayerProjections', {player}, player);

                const expandedPlayer = PlayerService.exec(
                    'getExpandedEntityParams',
                    {
                        player,
                        userPointsType: userPointsType.getUserPointsType(),
                        sportConfig,
                    },
                    {},
                );

                indexedPlayers[playersData.players.doIndex(player.playerId)] = {...expandedPlayer};
            });

            const updatedPlayersPool = {...existingPlayers, ...indexedPlayers};

            dispatch(this.updatePlayersState(updatedPlayersPool));

            dispatch(this.setPointsBoundary());
            dispatch(this.setSalaryBoundary());

            PlayerService.exec('afterGettingPlayers', {dispatch}, {});

            dispatch(this.setPlayersCounters());

            return dispatch(this.setIsPlayersGroupReady(true));
        };
    },
    updatePlayersState(players, modificationType = Const.PLAYERS_MODIFICATION_TYPE_SET) {
        return {
            type: Const.GET_PLAYERS_SUCCESS,
            data: {
                players,
                modificationType,
            },
        };
    },
    unsetPlayers() {
        return {
            type: Const.UNSET_PLAYERS,
        };
    },

    setPlayersExposureFromStorage(playersExposure) {
        return {
            type: Const.SET_PLAYERS_EXPOSURE,
            data: playersExposure,
        };
    },

    setPlayersExposure(playersExposure, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_PLAYERS_EXPOSURE,
                data: playersExposure,
            });

            if (!saveToStorage) {
                return;
            }

            dispatch(
                this.saveDataToStorage('userExposure', (state) => {
                    const {
                        playersData: {players},
                        modesConfig,
                    } = state;
                    const modes = modesConfig.all({asArr: true}).map((mode) => mode.getRole());
                    const defaultExposureMax = getDefaultExposure('max');
                    const defaultExposureMin = getDefaultExposure('min');

                    const userExposure = [];
                    players.getAllAsArr().map((player) => {
                        const {playerId} = player;

                        modes.map((mode) => {
                            const expMaxPropName = player.getPropNameOfMode('exposureMax', mode);
                            if (player[expMaxPropName] < defaultExposureMax) {
                                userExposure.push({playerId, exposureMax: player[expMaxPropName], mode});
                            }

                            const expMinPropName = player.getPropNameOfMode('exposureMin', mode);
                            if (player[expMinPropName] > defaultExposureMin) {
                                userExposure.push({playerId, exposureMin: player[expMinPropName], mode});
                            }
                        });

                        if ('overall_exposureMax' in player && player.overall_exposureMax < defaultExposureMax) {
                            userExposure.push({playerId, exposureMax: player.overall_exposureMax, mode: '*'});
                        }
                    });

                    return userExposure;
                }),
            );
        };
    },
    setPlayersDominator(dominators) {
        return (dispatch) => {
            dispatch({
                type: Const.SET_DOMINATOR,
                dominators,
            });

            dispatch(
                this.saveDataToStorage('dominators', function (state) {
                    const {
                        playersData: {players},
                    } = state;

                    return players.getAllAsArr().map((player) => {
                        const {playerId, dominator} = player;

                        return {playerId, dominator};
                    });
                }),
            );
        };
    },
    recalculatePlayersScores() {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            return getPlayerService(sportConfig).exec('resetPoints', {dispatch});
        };
    },
    setUserPoints(items, mode, manually = true, options = {}) {
        return (dispatch) => {
            const {countPlayers = true} = options;

            dispatch({
                type: Const.SET_PLAYERS_POINTS,
                items,
                mode,
                manually,
            });

            dispatch({
                type: Const.SET_PLAYERS_SCORES,
                items,
                mode,
            });

            dispatch(this.setPointsBoundary([mode]));

            countPlayers && dispatch(this.setPlayersCounters());

            dispatch(this.saveFiltersToStorage('playersData'));
        };
    },
    setProjectedOwnershipsFromCsv(data) {
        return (dispatch) => {
            dispatch({
                type: Const.SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_CSV,
                data,
            });

            dispatch(
                Action.saveDataToStorage('projectedOwnerships', function (state) {
                    const {
                        playersData: {players},
                    } = state;

                    const data = {};
                    players.getAllAsArr().map((player) => {
                        const projectedOwnerships = player.projOwn.getValueToSaveInStorage();
                        if (!isEmpty(projectedOwnerships)) {
                            data[player.getId()] = projectedOwnerships;
                        }
                    });

                    return data;
                }),
            );
        };
    },
    setProjectedOwnershipsFromStorage(data) {
        return {
            type: Const.SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_STORAGE,
            data,
        };
    },
    resetExcludePlayersByRange() {
        return {
            type: Const.RESET_EXCLUDE_PLAYERS_BY_RANGE,
        };
    },
    applySympathy() {
        return (dispatch, getState) => {
            const {
                sportConfig,
                playersData: {players},
                playersSympathy,
            } = getState();

            const updatedPlayers = getPlayerService(sportConfig).exec('applySympathy', {players, playersSympathy}, {});

            return dispatch(this.updatePlayersState(updatedPlayers));
        };
    },
};

export default Player;
